import { render, staticRenderFns } from "./Dewu.vue?vue&type=template&id=532434e5&scoped=true&"
import script from "./Dewu.vue?vue&type=script&lang=js&"
export * from "./Dewu.vue?vue&type=script&lang=js&"
import style0 from "./Dewu.vue?vue&type=style&index=0&id=532434e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532434e5",
  null
  
)

export default component.exports